/*
 * @Author: Dom
 * @Date: 2022-07-01 15:36:25
 * @LastEditTime: 2022-07-01 15:53:55
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\services\fddsign.ts
 */
import request from '@/utils/request';
import qs from 'qs'
import {ShipmentOrderType} from './data'

//法大大认证
export async function fddAuthentication(params:ShipmentOrderType): Promise<any> {
    return request({
        url: '/seller/v1/user/fddAuthentication',
        method: 'POST',
        data: qs.stringify(params),
    });
}

//法大大签署
export async function fddContract(params:ShipmentOrderType): Promise<any> {
    return request({
        url: '/seller/v1/user/fddContract',
        method: 'POST',
        data: qs.stringify(params),
    });
}
